import { render, staticRenderFns } from "./InputCabinClass.vue?vue&type=template&id=2b898b22"
import script from "./InputCabinClass.vue?vue&type=script&lang=js"
export * from "./InputCabinClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsExpand: require('/home/forge/ab.farescraper.com/components/IconsExpand.vue').default,AppDropdown: require('/home/forge/ab.farescraper.com/components/AppDropdown.vue').default})
